import React from "react";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";
import Button from "../../../form/Button";
import useForm from "../../../../hooks/useForm";
import useMutation from "../../../../hooks/useMutation";
import { contactAddEdit } from "../../../../services/contactService";
import { toast } from "react-toastify";

const ContactForm = () => {
  const validation = {
    name: { required: true, message: "Title is required" },
    email: [
      {
        type: "email",
        required: true,
        message: "Enter valid Email",
      },
    ],
  };

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    formValidate,
    resetField,
  } = useForm({
    validationRules: validation,
    initialState: {
      name: "",
      email: "",
      comment: "",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await contactAddEdit({
        ...val,
      });
    },
    onSuccess: (res) => {
      toast.success(res.message || "Data Added Successfully");
      resetField();
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <>
      <div className="relative bg-white py-10 px-8 md:px-16 rounded-4xl shadow-md w-full space-y-8">
        <h2 className="text-2xl font-bold text-chestnut-rose text-center">
          Get in Touch
        </h2>
        <form onSubmit={(event) => handleSubmit(event, mutate)}>
          <div className="relative">
            <div className="relative mb-6">
              <Input
                label={"Name"}
                labelClasses={"mb-2 !text-gable-green"}
                inputClasses={"bg-transparent rounded-lg !h-12"}
                inputPlaceholder={"Enter Your Name"}
                inputName="name"
                value={values?.name}
                onChange={handleChange}
                {...formValidate(errors, "name")}
              />
            </div>
            <div className="relative mb-6">
              <Input
                label={"Email"}
                labelClasses={"mb-2 !text-gable-green"}
                inputClasses={"bg-transparent rounded-lg !h-12"}
                inputPlaceholder={"Enter email address"}
                inputName="email"
                value={values?.email}
                onChange={handleChange}
                {...formValidate(errors, "email")}
              />
            </div>
            <div className="relative mb-6">
              <Textarea
                label={"Message"}
                labelClasses={"mb-2 !text-gable-green"}
                inputClasses={"bg-transparent rounded-lg"}
                inputPlaceholder={"Write your comment"}
                inputName="comment"
                inputValue={values?.comment}
                onChange={handleChange}
                {...formValidate(errors, "comment")}
              />
            </div>
            <div className="relative">
              <Button
                buttonLabel={"Submit"}
                buttonType="submit"
                buttonClasses={"w-full !h-14 !rounded-lg"}
                buttonLabelClasses={"!text-xl"}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
